import React, { createContext, useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const stored = localStorage.getItem('norixCart');
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem('norixCart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, size, quantity = 1, isPreOrder = false, preOrderType = null) => {
    setCart(prev => {
      const exists = prev.find(i => i.product._id === product._id && i.size === size && i.isPreOrder === isPreOrder);
      if (exists) {
        toast.success('Quantity updated');
        return prev.map(i =>
          i.product._id === product._id && i.size === size && i.isPreOrder === isPreOrder
            ? { ...i, quantity: i.quantity + quantity }
            : i
        );
      }
      toast.success('Added to cart!');
      return [...prev, { product, size, quantity, isPreOrder, preOrderType, price: product.salePrice || product.discountedPrice || product.price }];
    });
  };

  const removeFromCart = (productId, size) => {
    setCart(prev => prev.filter(i => !(i.product._id === productId && i.size === size)));
    toast('Removed from cart', { icon: '🗑️' });
  };

  const updateQty = (productId, size, quantity) => {
    if (quantity < 1) return;
    setCart(prev => prev.map(i =>
      i.product._id === productId && i.size === size ? { ...i, quantity } : i
    ));
  };

  const clearCart = () => setCart([]);

  const cartTotal = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const cartCount = cart.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQty, clearCart, cartTotal, cartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
